import { proxy } from 'valtio'
import { isBrowser } from '../lib/helpers'

export function createProxyState (initialState) {
  if (isBrowser) {
    return proxy(initialState)
  }
  return initialState
}
